import { type ClassValue, clsx } from "clsx"
import { NextRequest } from "next/server"

import { twMerge } from "tailwind-merge"

interface PaymentDetails {
    payload: string
}

interface FormDataPayload {
    centraPaymentMethod: string
    details: PaymentDetails
    paymentData: string
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

type PaymentInfo = {
    centraPaymentMethod: string
    details: { [key: string]: string }
    paymentData: string
}

export function mergePaymentData(
    centraPaymentMethod: string,
    details: Array<{ name: string; value: string }>
): PaymentInfo {
    const paymentInfo: PaymentInfo = {
        centraPaymentMethod: centraPaymentMethod,
        details: {},
        paymentData: ""
    }

    details.forEach(detail => {
        if (detail.name === "details[payload]") {
            paymentInfo.details["payload"] = detail.value
        } else if (detail.name === "paymentData") {
            paymentInfo.paymentData = detail.value
        }
    })

    return paymentInfo
}

export async function mergeFormData(request: NextRequest): Promise<FormDataPayload> {
    const formData = await request.formData()
    const detailsPayload = formData.get("details[payload]")
    const paymentData = formData.get("paymentData")

    const payload: FormDataPayload = {
        centraPaymentMethod: "adyen-drop-in-eu-test",
        details: {
            payload: detailsPayload ? detailsPayload.toString() : ""
        },
        paymentData: paymentData ? paymentData.toString() : ""
    }

    return payload
}

export function transformAndStringifyPaymentResultData(input: any) {
    const { token, order, location } = input

    const transformedData = {
        token,
        order: {
            ...order,
            items: order.items.map((item: any) => ({
                ...item
            }))
        },
        location: {
            ...location
        }
    }

    return JSON.stringify(transformedData)
}

const envBaseUrls: { [key: string]: string } = {
    localhost: "https://localhost:3000",
    production: "https://qa-pocsports-ecom.vercel.app",
    qa: "https://qa-pocsports-ecom.vercel.app",
    development: "https://localhost:3000",
    preproduction: "https://beta-poc.vercel.app"
}

export const getEnvironmentBaseUrl = (environment: string): string => {
    return envBaseUrls[environment] || envBaseUrls.local
}

export function convertSnakeCaseToUpperCase(input: string): string {
    if (!input) {
        return ""
    }
    return input
        .split("_")
        .map(word => word.toUpperCase())
        .join(" ")
}

export const splitOptionValue = (optionValue: string): [string, string] => {
    const splitIndex = optionValue.lastIndexOf("(")
    const deliveryMethod = optionValue.substring(0, splitIndex).trim()
    let deliveryTime = optionValue.substring(splitIndex).trim()
    deliveryTime = deliveryTime.replace(/\(|\)|business days/g, "").trim()
    return [deliveryMethod, deliveryTime]
}

export const removeTrailingSlash = (url: string): string => {
    return url.endsWith("/") ? url.replace(/\/+$/, "") : url
}
